import { memo, useRef } from 'react';
import FloatAnimation, { FloatAnimationVariant } from './FloatAnimation';

interface IconProps {
  className?: string;
}

// Front cloud path (with blur) used for both clip-path and visual rendering
const FRONT_CLOUD_PATH =
  'M38.0684 38C50.2823 38 60.1836 47.9013 60.1836 60.1152C60.1836 60.5608 60.1695 61.0033 60.1436 61.4424H67.3457C76.6283 61.4424 84.1543 68.9674 84.1543 78.25C84.1541 87.5325 76.6282 95.0576 67.3457 95.0576H17.8076C8.52513 95.0576 1.00016 87.5325 1 78.25C1 69.5784 7.56695 62.4402 15.999 61.5381C15.9691 61.0676 15.9531 60.5932 15.9531 60.1152C15.9531 47.9012 25.8544 38 38.0684 38Z';

function OvercastIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-overcast"
    >
      {/* Back cloud - solid white, below */}
      <path
        d="M72.0684 25C84.2823 25 94.1836 34.9013 94.1836 47.1152C94.1836 47.5608 94.1695 48.0033 94.1436 48.4424H101.346C110.628 48.4424 118.154 55.9674 118.154 65.25C118.154 74.5325 110.628 82.0576 101.346 82.0576H51.8076C42.5251 82.0576 35.0002 74.5325 35 65.25C35 56.5784 41.5669 49.4402 49.999 48.5381C49.9691 48.0676 49.9531 47.5932 49.9531 47.1152C49.9531 34.9012 59.8544 25 72.0684 25Z"
        fill="white"
      >
        <FloatAnimation variant={FloatAnimationVariant.FastBob} />
      </path>
      {/* Front cloud group - foreignObject and path animate together */}
      <g>
        <FloatAnimation />
        {/* Backdrop blur effect using foreignObject with clip-path */}
        <foreignObject x="-19" y="18" width="123.154" height="97.0576">
          <div
            // @ts-expect-error xmlns is valid for foreignObject content
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              clipPath: 'url(#bgblur_overcast_clip)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        {/* Front cloud overlay with semi-transparent fill */}
        <path d={FRONT_CLOUD_PATH} fill="white" fillOpacity="0.7" />
      </g>
      <defs>
        {/* Clip path for backdrop blur - offset to match foreignObject position */}
        <clipPath id="bgblur_overcast_clip" transform="translate(19 -18)">
          <path d={FRONT_CLOUD_PATH} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(OvercastIcon);
